import { createFileRoute } from '@tanstack/react-router'
import { ProfileSettingsPage } from '../components/auth-pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/de/einstellungen/profil')({
  head: () => noIndexRouteHead('settingsProfile', 'de'),
  component: ProfileSettingsPage,
})
